import { useLocalStorage } from '@easeltv/hooks';
import { useEffect, useState } from 'react';

import { useDictionaryObject } from '../../../hooks/useDictionary/useDictionary';
import { Portal } from '..';
import DumbAppConsent, { Consent, CONSENT_VERSION } from './AppConsent.dumb';

/* -------------------------------- Component ------------------------------- */

const AppConsent = () => {
    const labels = useDictionaryObject({
        body: 'web.consent.popup.body',
        all: 'web.consent.popup.button.accept-all',
        essential: 'web.consent.popup.button.reject-all',
        footer: 'web.consent.popup.footer',
        footerLinkLabel: 'web.consent.popup.footer.link.label',
        heading: 'web.consent.popup.heading',
    });

    const [needsConsent, setNeedsConsent] = useState(false);
    const [consentValue, setConsentValue] = useLocalStorage<Consent>(
        'easel.consent',
        {
            version: CONSENT_VERSION,
            decision: 'empty',
        },
    );

    useEffect(() => {
        if (
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.includes('Europe') &&
            (consentValue.version < CONSENT_VERSION ||
                consentValue.decision === 'empty')
        )
            setNeedsConsent(true);
        else setNeedsConsent(false);
    }, [consentValue]);

    return (
        <Portal canDismiss={false} initialShowModal={needsConsent}>
            {({ Modal }) => (
                <Modal>
                    <DumbAppConsent
                        setConsentValue={setConsentValue}
                        labels={labels}
                    />
                </Modal>
            )}
        </Portal>
    );
};

/* --------------------------------- Export --------------------------------- */

export default AppConsent;
